import React, {
    useEffect,
    useState
} from "react";

import {
    useNavigate,
    useParams
} from "react-router-dom";

import { useDispatch, useSelector } from 'react-redux';

import ProductFilters
    from "./ProductFilters";

import ProductDiscoveryCard
    from "./ProductDiscoveryCard";

import CATEGORY_IMAGES
    from "../../config/categoryImages";

import {
    Row,
    Col,
    Button,
    Space,
    Typography,
    Spin
} from "antd";

import {
    ArrowLeftOutlined
} from "@ant-design/icons";

import {
    getMarketplaceBySubCategory
} from "../../servics/product/MarketplaceApi";

import {
    setMarketplaceProducts
} from "../../store/reducers/marketplaceSlice";

const CategoryCatalog = () => {
    const dispatch = useDispatch();

    const navigate = useNavigate();

    const { subCategoryId } = useParams();

    const [products, setProducts] =
        useState([]);

    const [loading, setLoading] =
        useState(false);

    const [search, setSearch] =
        useState("");

    const [region, setRegion] =
        useState(null);

    const activityCountry =
        useSelector(
            state => state.country.activityCountry
        );

    useEffect(() => {

        if(activityCountry?.value){

            loadMarketplace();
        }

    }, [
        subCategoryId,
        activityCountry
    ]);

    const loadMarketplace = async () => {

        try {

            setLoading(true);

            const data =
                await getMarketplaceBySubCategory(

                    subCategoryId,

                    activityCountry?.value
                );

            console.log(
                "MARKETPLACE DATA =",
                data
            );

            setProducts(data);

            dispatch(
                setMarketplaceProducts(data)
            );

        } catch (e) {

            console.error(
                "LOAD MARKETPLACE ERROR",
                e
            );

        } finally {

            setLoading(false);
        }
    };

    useEffect(() => {

        loadMarketplace();

    }, [subCategoryId]);

    const filteredProducts =
        products.filter(product => {

            const matchesRegion =
                !region ||
                product.city === region;

            const matchesSearch =
                !search ||

                product.productName
                    ?.toLowerCase()
                    .includes(
                        search.toLowerCase()
                    );

            return (
                matchesRegion &&
                matchesSearch
            );
        });

    return (

        <div style={{ padding: 24 }}>

            <Space
                direction="vertical"
                size={4}
                style={{
                    width: "100%",
                    marginBottom: 24
                }}
            >

                <Button
                    type="text"
                    icon={<ArrowLeftOutlined />}
                    onClick={() => navigate(-1)}
                    style={{
                        width: "fit-content",
                        paddingLeft: 0,
                        fontWeight: 600
                    }}
                >
                    Retour aux categories
                </Button>

                <Typography.Title
                    level={3}
                    style={{ margin: 0 }}
                >
                    🌾 Marketplace Agricole
                </Typography.Title>

                <Typography.Text type="secondary">

                    Découvrez les produits
                    agricoles disponibles
                    dans cette catégorie.

                </Typography.Text>

            </Space>

            <ProductFilters

                region={region}

                setRegion={setRegion}

                search={search}

                setSearch={setSearch}
            />

            {
                loading ? (

                    <Spin />

                ) : (

                    <Row
                        gutter={[16,16]}
                        style={{
                            marginTop: 20
                        }}
                    >

                        {filteredProducts.map(product => {

                            const categoryImage =

                                CATEGORY_IMAGES[
                                    product.subCategoryName
                                    ] ||

                                CATEGORY_IMAGES.default;

                            return (

                                <Col
                                    xs={24}
                                    md={12}
                                    lg={8}
                                    key={product.id}
                                >

                                    <ProductDiscoveryCard

                                        product={product}

                                        categoryImage={
                                            categoryImage
                                        }
                                    />

                                </Col>
                            );
                        })}

                    </Row>
                )
            }

        </div>
    );
};

export default CategoryCatalog;